/* ==========================================================================
   PLENNIA PLAN ENGINE  ·  assets/plennia-plan-engine.js
   --------------------------------------------------------------------------
   Shared portion + subscription-assembly engine for the plan LIST and plan
   DETAIL pages. Ported verbatim from sections/plennia-plans.liquid (the shelf)
   so the maths, cadence and cart rules stay identical — no new logic.

   Reads window.PLENNIA_PLANS_DATA (emitted by each section's Liquid) and
   exposes window.PlenniaPlanEngine. Every subscription still = dry bag + wet
   trays, each line carrying its own weekly selling plan; dry-only is never a
   subscription; €30.25 inc-VAT floor guard preserved.
   ========================================================================== */
(function () {
  var D = window.PLENNIA_PLANS_DATA || { foods: [], locale: 'en' };
  var LANG = (D.locale && D.locale.indexOf('es') === 0) ? 'es' : 'en';

  var T = {
    es: {
      cats: "Planes para gatos", dogs: "Planes para perros",
      sub: "Elige un plan, dinos el peso y listo: raciones reales, entregas a su ritmo y siempre con húmedo en el bol.",
      trust: ["−10% en cada entrega", "Envío siempre gratis", "Pausa o cancela cuando quieras", "Todo plan incluye húmedo"],
      mix_light: "El Diario", mix_hero: "El Equilibrio", fullwet: "El Festín",
      mix_light_d: "La entrada más económica: su ración de pienso + una bandeja de húmedo para el paladar y la hidratación.",
      mix_hero_d: "Nuestro equilibrio recomendado — ración completa de pienso con un topper de húmedo (~20% de sus calorías) para sabor e hidratación.",
      fullwet_cat_d: "El húmedo como comida principal. Ideal para gatos: máxima hidratación y palatabilidad.",
      fullwet_dog_d: "El húmedo como comida principal. Pensado para perros pequeños; para medianos y grandes recomendamos El Equilibrio.",
      hero_flag: "Más elegido", weight: "Peso (kg)",
      dry_l: "Receta seca", wet_l: "Receta húmeda",
      every: "Entrega cada", weeks: "semanas",
      per: "por entrega", from_day: "desde", day: "día", from: "desde",
      cta: "Suscribirme", adding: "Añadiendo…", added: "Añadido ✓ abriendo carrito…",
      tray: "bandeja de 16", case32: "caja de 32", lasts: "dura ~", wk: "sem",
      portion: "Ración diaria estimada", dry: "seco", wet: "húmedo", cups: "latas",
      bigdog: "Para un perro de este tamaño la caja de húmedo se hace grande — El Equilibrio suele ser mejor (y más económico).",
      view_plan: "Ver el plan", choose_plan: "Elegir este plan",
      byo_h: "¿Prefieres crearlo a tu medida?",
      byo_d: "Combina recetas y cantidades con el quiz de 3 minutos. Toda suscripción a medida incluye húmedo — el seco solo se compra suelto.",
      byo_cta: "Crear mi plan con el quiz",
      switch_dogs: "Ver planes para perros", switch_cats: "Ver planes para gatos",
      back_plans: "Volver a los planes", whats_in: "Qué incluye tu entrega",
      foot: "Suscripción con −10% y envío gratis siempre · Sin compromiso, pausa o cancela desde tu cuenta · Recetas formuladas según normativa FEDIAF.",
      err: "No se pudo añadir al carrito."
    },
    en: {
      cats: "Cat plans", dogs: "Dog plans",
      sub: "Pick a plan, set the weight, done: real portions, deliveries at their rhythm, and always wet food in the bowl.",
      trust: ["10% off every delivery", "Always free shipping", "Pause or cancel anytime", "Every plan includes wet"],
      mix_light: "The Everyday", mix_hero: "The Balance", fullwet: "The Feast",
      mix_light_d: "The easiest way in: their dry ration + one wet tray for taste and hydration.",
      mix_hero_d: "Our recommended balance — a full dry ration topped with wet (~20% of their calories) for taste and hydration.",
      fullwet_cat_d: "Wet food as the main meal. Ideal for cats: maximum hydration and palatability.",
      fullwet_dog_d: "Wet food as the main meal. Designed for small dogs; for medium and large dogs we recommend The Balance.",
      hero_flag: "Most chosen", weight: "Weight (kg)",
      dry_l: "Dry recipe", wet_l: "Wet recipe",
      every: "Delivered every", weeks: "weeks",
      per: "per delivery", from_day: "from", day: "day", from: "from",
      cta: "Subscribe", adding: "Adding…", added: "Added ✓ opening cart…",
      tray: "16-cup tray", case32: "32-cup case", lasts: "lasts ~", wk: "wk",
      portion: "Estimated daily portion", dry: "dry", wet: "wet", cups: "cups",
      bigdog: "For a dog this size the wet box gets big — The Balance is usually a better (and cheaper) fit.",
      view_plan: "View plan", choose_plan: "Choose this plan",
      byo_h: "Prefer to build your own?",
      byo_d: "Combine recipes and quantities with the 3-minute quiz. Every custom subscription includes wet — dry-only is available as a one-off purchase.",
      byo_cta: "Build my plan with the quiz",
      switch_dogs: "See dog plans", switch_cats: "See cat plans",
      back_plans: "Back to plans", whats_in: "What's in your delivery",
      foot: "Subscriptions get 10% off and always ship free · No commitment — pause or cancel from your account · Recipes formulated to FEDIAF standards.",
      err: "Could not add to cart."
    }
  };
  function t(k) { return T[LANG][k] !== undefined ? T[LANG][k] : k; }
  function esc(s) { return (s == null ? '' : ('' + s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { var s = n.toFixed(2); if (LANG === 'es') s = s.replace('.', ','); return '€' + s; }
  function num(n) { var s = ('' + n); return LANG === 'es' ? s.replace('.', ',') : s; }

  // ---- Catalog parsing (same tag model as the quiz) ----
  function tagVal(tags, pre) { for (var i = 0; i < tags.length; i++) { if (tags[i].indexOf(pre) === 0) return tags[i].slice(pre.length); } return null; }
  function has(tags, x) { return tags.indexOf(x) > -1; }
  var PROT_LBL = { salmon: ['Salmón', 'Salmon'], chicken: ['Pollo', 'Chicken'], turkey: ['Pavo', 'Turkey'], tuna: ['Atún', 'Tuna'], beef: ['Ternera', 'Beef'], lamb: ['Cordero', 'Lamb'], pork: ['Cerdo', 'Pork'], seafood: ['Marisco', 'Seafood'] };
  function recLabel(P) { var ps = (P.proteins || []).map(function (p) { return PROT_LBL[p] ? (LANG === 'es' ? PROT_LBL[p][0] : PROT_LBL[p][1]) : p; }); return ps.length ? ps.join(' & ') : P.title; }
  function parseProduct(raw) {
    var tg = raw.tags || [];
    var variants = (raw.variants || []).map(function (v) {
      var grams = 0, cups = 0;
      var kg = (v.title || '').match(/([\d.]+)\s*kg/i); if (kg) grams = parseFloat(kg[1]) * 1000;
      var pk = (v.title || '').match(/(\d+)\s*[x×]\s*\d+\s*g/i) || (v.title || '').match(/(\d+)\s*(?:-?\s*pack|cups?|trays?|cases?)/i) || (v.title || '').match(/(?:tray|case|caja|bandeja)\s*(\d+)/i);
      if (pk) cups = parseInt(pk[1], 10);
      return { id: v.id, sku: v.sku, label: v.title, price: v.price / 100, available: v.available, sps: (v.sps || []), grams: grams, cups: cups };
    });
    return {
      id: raw.id, title: raw.title, url: raw.url, img: raw.img, tags: tg,
      species: tagVal(tg, 'species_') || tagVal(tg, 'pet_'),
      proteins: (function () { var o = []; tg.forEach(function (x) { if (x.indexOf('protein_') === 0) o.push(x.slice(8)); }); return o; })(),
      format: has(tg, 'format_wet') ? 'wet' : (has(tg, 'format_dry') ? 'dry' : 'other'),
      role: has(tg, 'role_main_food'),
      priority: has(tg, 'quiz_priority_high') ? 1 : (has(tg, 'quiz_priority_medium') ? 0.5 : 0),
      hero: has(tg, 'hero_product'), variants: variants, mf: raw.mf || {}
    };
  }
  var FOODS = (D.foods || []).map(parseProduct);
  function pool(species, fmt) {
    return FOODS.filter(function (P) {
      return P.role && P.species === species && P.format === fmt && (P.variants || []).some(function (v) { return v.available; });
    }).sort(function (a, b) {
      if (b.priority !== a.priority) return b.priority - a.priority;
      if (!!b.hero !== !!a.hero) return (b.hero ? 1 : 0) - (a.hero ? 1 : 0);
      var ap = Math.min.apply(null, a.variants.map(function (v) { return v.price; }));
      var bp = Math.min.apply(null, b.variants.map(function (v) { return v.price; }));
      return ap - bp;
    });
  }

  // ---- Portion engine (identical to the shelf) ----
  function merKcal(species, kg) { if (species === 'cat') return 95 * Math.pow(kg, 0.67); return 119 * Math.pow(kg, 0.75); }
  function cupKcal(P) { return (P && P.mf && P.mf.kkg > 0 && P.mf.ug > 0) ? (P.mf.ug * P.mf.kkg / 1000) : (P && P.species === 'cat' ? 77 : 90); }
  function dryGPerDay(P, kcal) { var e = (P && P.mf && P.mf.kkg > 0) ? P.mf.kkg / 1000 : 3.7; return kcal / e; }

  var BASE_INTERVALS = [2, 3, 4, 6, 8];
  function weeksOfPlan(n) { var m = (n || '').match(/(\d+)\s*(?:week|semana)/i); return m ? parseInt(m[1], 10) : 0; }
  function availableWeeks() {
    var set = {}; FOODS.forEach(function (P) { (P.variants || []).forEach(function (v) { (v.sps || []).forEach(function (s) { var w = weeksOfPlan(s.n); if (w) set[w] = 1; }); }); });
    var arr = BASE_INTERVALS.filter(function (w) { return set[w]; }); return arr.length ? arr : BASE_INTERVALS;
  }
  var INTERVALS = availableWeeks();
  function nearestInterval(days) { var best = INTERVALS[0], bd = 1e9; INTERVALS.forEach(function (w) { var d = Math.abs(Math.log((w * 7) / Math.max(1, days))); if (d < bd) { bd = d; best = w; } }); return best; }
  function planFor(v, weeks) {
    var sps = v.sps || []; if (!sps.length) return null;
    var ex = sps.filter(function (s) { return weeksOfPlan(s.n) === weeks; })[0]; if (ex) return ex.id;
    var best = null, bd = 1e9; sps.forEach(function (s) { var w = weeksOfPlan(s.n); if (!w) return; var d = Math.abs(w - weeks); if (d < bd) { bd = d; best = s.id; } });
    return best;
  }
  function trayLines(P, trays, weeks) {
    var vs = (P.variants || []).filter(function (v) { return v.cups === 16 || v.cups === 32; });
    var av = vs.filter(function (v) { return v.available; }); if (av.length) vs = av;
    var v16 = null, v32 = null; vs.forEach(function (v) { if (v.cups === 16) v16 = v; if (v.cups === 32) v32 = v; });
    var lines = []; var cups = trays * 16;
    if (v32) {
      var n32 = Math.floor(cups / 32); if (n32 > 0) lines.push({ v: v32, qty: n32, product: P, cups: 32 });
      if (cups - n32 * 32 > 0) { if (v16) lines.push({ v: v16, qty: 1, product: P, cups: 16 }); else if (lines.length) lines[0].qty += 1; else lines.push({ v: v32, qty: 1, product: P, cups: 32 }); }
    } else if (v16) { lines.push({ v: v16, qty: Math.ceil(cups / 16), product: P, cups: 16 }); }
    lines.forEach(function (l) { l.sp = planFor(l.v, weeks); });
    return lines;
  }
  function planBag(P, species, dryG) {
    var bags = (P.variants || []).filter(function (v) { return v.grams > 0 && v.available; }).sort(function (a, b) { return a.grams - b.grams; });
    if (!bags.length) return null;
    if (species === 'dog') { for (var i = bags.length - 1; i >= 0; i--) { if (bags[i].grams / Math.max(1, dryG) <= 63) return bags[i]; } return bags[0]; }
    return bags[0];
  }

  // ---- Plan configs (same 5 as the shelf) ----
  var CARDS = [
    { key: 'cat_light', species: 'cat', type: 'mix', level: 'light', w: 4.5, title: 'mix_light', desc: 'mix_light_d' },
    { key: 'cat_hero', species: 'cat', type: 'mix', level: 'hero', w: 4.5, title: 'mix_hero', desc: 'mix_hero_d', hero: true },
    { key: 'cat_wet', species: 'cat', type: 'fullwet', w: 4.5, title: 'fullwet', desc: 'fullwet_cat_d' },
    { key: 'dog_hero', species: 'dog', type: 'mix', level: 'hero', w: 15, title: 'mix_hero', desc: 'mix_hero_d', hero: true },
    { key: 'dog_wet', species: 'dog', type: 'fullwet', w: 7, title: 'fullwet', desc: 'fullwet_dog_d' }
  ];
  function cardByKey(key) { for (var i = 0; i < CARDS.length; i++) { if (CARDS[i].key === key) return CARDS[i]; } return null; }
  function cardsBySpecies(sp) { return CARDS.filter(function (c) { return c.species === sp; }); }
  function defaultState(key) { var c = cardByKey(key); return { w: c ? c.w : 4.5, dryId: null, wetId: null }; }
  function stepFor(sp) { return sp === 'cat' ? 0.5 : 1; }
  function clampW(sp, w) { var lo = 2, hi = sp === 'cat' ? 12 : 60; return Math.min(hi, Math.max(lo, Math.round(w * 10) / 10)); }

  function compute(key, st) {
    var c = cardByKey(key); if (!c) return null;
    st = st || defaultState(key);
    var dryPool = pool(c.species, 'dry'), wetPool = pool(c.species, 'wet');
    var dryP = dryPool.filter(function (P) { return P.id === st.dryId; })[0] || dryPool[0];
    var wetP = wetPool.filter(function (P) { return P.id === st.wetId; })[0] || wetPool[0];
    if (!wetP) return null;
    var kcal = merKcal(c.species, st.w);
    var out = { card: c, species: c.species, dryPool: dryPool, wetPool: wetPool, dryP: dryP, wetP: wetP, lines: [], weeks: 4, bigDog: false };
    if (c.type === 'mix') {
      if (!dryP) return null;
      var dryG = dryGPerDay(dryP, kcal * 0.8);
      var bag = planBag(dryP, c.species, dryG); if (!bag) return null;
      var bagDays = bag.grams / Math.max(1, dryG);
      out.weeks = nearestInterval(bagDays);
      var days = out.weeks * 7;
      var topCups = (kcal * 0.2) / cupKcal(wetP);
      var heroTrays = Math.max(1, Math.round(topCups * days / 16));
      var trays = c.level === 'light' ? Math.max(1, Math.floor(heroTrays / 2)) : heroTrays;
      out.lines = [{ v: bag, qty: 1, product: dryP, sp: planFor(bag, out.weeks), lastsDays: bagDays }].concat(trayLines(wetP, trays, out.weeks));
      out.dryG = Math.round(dryG); out.wetCups = Math.round(trays * 16 / days * 10) / 10; out.trays = trays;
    } else {
      var cd = kcal / cupKcal(wetP);
      var best = null;
      for (var i = INTERVALS.length - 1; i >= 0; i--) { var w = INTERVALS[i]; var tr = Math.max(1, Math.round(cd * w * 7 / 16)); if (tr <= 6) { best = { w: w, tr: tr }; break; } }
      if (!best) { var w0 = INTERVALS[0]; best = { w: w0, tr: Math.max(1, Math.round(cd * w0 * 7 / 16)) }; if (c.species === 'dog') out.bigDog = true; }
      if (c.species === 'dog' && st.w > 12) out.bigDog = true;
      out.weeks = best.w; out.lines = trayLines(wetP, best.tr, best.w);
      out.dryG = 0; out.wetCups = Math.round(cd * 10) / 10; out.trays = best.tr;
    }
    out.base = out.lines.reduce(function (s, l) { return s + l.v.price * l.qty; }, 0);
    out.sub = out.lines.reduce(function (s, l) { return s + (l.sp ? l.v.price * l.qty * 0.9 : l.v.price * l.qty); }, 0);
    out.anySp = out.lines.some(function (l) { return !!l.sp; });
    out.hasWet = out.lines.some(function (l) { return l.product && l.product.format === 'wet'; });
    out.floorOk = out.sub >= 30.25;
    out.ok = out.anySp && out.hasWet && out.floorOk;
    out.perDay = out.sub / (out.weeks * 7);
    return out;
  }

  function addLines(lines) {
    var items = lines.map(function (l) { var it = { id: l.v.id, quantity: l.qty }; if (l.sp) it.selling_plan = l.sp; return it; });
    // /cart/add.js answers 422 with a JSON body when a variant is sold out or the quantity is
    // unavailable — r.json() alone resolves and the caller would treat the failure as success.
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (body) {
        if (!r.ok) throw new Error((body && (body.description || body.message)) || t('err'));
        return body;
      });
    });
  }

  function planImg(r) { var c = r.card; return (c.type === 'mix' && r.dryP && r.dryP.img) ? r.dryP.img : (r.wetP && r.wetP.img ? r.wetP.img : ''); }

  window.PlenniaPlanEngine = {
    lang: LANG, t: t, esc: esc, money: money, num: num, recLabel: recLabel,
    CARDS: CARDS, cardByKey: cardByKey, cardsBySpecies: cardsBySpecies,
    defaultState: defaultState, stepFor: stepFor, clampW: clampW,
    pool: pool, compute: compute, addLines: addLines, planImg: planImg,
    cartUrl: D.cartUrl || '/cart', quizUrl: D.quizUrl || '/pages/plan'
  };
})();
